import { render } from "./SidebarComp.vue?vue&type=template&id=44613e42&scoped=true"
import script from "./SidebarComp.vue?vue&type=script&lang=js"
export * from "./SidebarComp.vue?vue&type=script&lang=js"

import "./SidebarComp.vue?vue&type=style&index=0&id=44613e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44613e42"]])

export default __exports__